import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import classes from "./FeedListv2.scss";
import UserNameAvatar from "AppComponents/UserNameAvatar";
import NoDataComponent from "UIComponents/NoDataComponent";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import {
  Dropdown,
  DropdownMenu,
  IconButton,
  Table,
  Tooltip,
} from "@toddle-edu/ds-web";
import {
  DotsHorizontalOutlined,
  DotsVerticalOutlined,
} from "@toddle-edu/ds-icons";
import update from "immutability-helper";
import { colors } from "Constants";
import classNames from "classnames";
import SkeletonLoader from "UIComponents/SkeletonLoader";

const disabledStyle = {
  color: colors.textDisabled,
};

const multiRowColumnStyle = {
  paddingLeft: 0,
  paddingRight: 0,
};
class FeedListv2 extends React.Component {
  constructor(props) {
    super(props);
    const { sortedFieldsWithOrder } = props;
    let filterConfig = [];
    if (!_.isEmpty(sortedFieldsWithOrder)) {
      filterConfig = Object.keys(sortedFieldsWithOrder).map(sortedFieldKey => {
        return {
          entity: sortedFieldKey,
          direction: sortedFieldsWithOrder[sortedFieldKey].direction,
          sortEntity: sortedFieldsWithOrder[sortedFieldKey].menuItemEntity,
        };
      });
    }

    this.state = { orderBy: {}, filterConfig };
    this.actionDropdownIconRef = React.createRef();
  }

  changeColumnSortDirection = ({
    id,
    updatedSortDirection,
    menuItemEntity,
  }) => {
    const { updateSortedFieldsWithOrder } = this.props;
    updateSortedFieldsWithOrder({
      id,
      sortDirection: updatedSortDirection,
      menuItemEntity,
    });
  };

  getOrderBy = ({ feedData }) => {
    const { orderBy } = this.state;
    if (!_.isEmpty(orderBy)) {
      const orderByKeys = [];
      const orderKeys = [];

      _.forEach(Object.keys(orderBy), key => {
        const item = orderBy[key];
        if (item.orderBy) {
          _.forEach(Object.keys(item.orderBy), orderByKey => {
            orderByKeys.push(orderByKey);
            orderKeys.push(item.orderBy[orderByKey]);
          });
        }
      });
      return _.orderBy(feedData, orderByKeys, orderKeys);
    }
    return feedData;
  };

  onFitlerDropdownOptionClick = filterConfig => {
    if (_.get(filterConfig, "length", 0) === 0) {
      this.changeColumnSortDirection({
        menuItemEntity: null,
        id: null,
        updatedSortDirection: null,
      });
      return;
    }
    const { direction, entity, sortEntity } = _.first(filterConfig);

    const updatedSort = {
      id: entity,
      updatedSortDirection: direction,
      menuItemEntity: sortEntity,
    };
    this.changeColumnSortDirection(updatedSort);
  };

  getHeaderLabelComponent = ({ label, tooltip }) => {
    if (tooltip) {
      return (
        <Tooltip tooltip={tooltip} placement={"bottom"}>
          <span>{label}</span>
        </Tooltip>
      );
    } else {
      return label;
    }
  };

  getHeaderValue = ({ label, tooltip, column }) => {
    const {
      HeaderRightComponent,
      headerRightComponentStyle = {},
      headerWithRightComponentRootStyle,
    } = column;

    if (HeaderRightComponent) {
      return (
        <div
          className={classes.headerWithRightComponent}
          style={headerWithRightComponentRootStyle}
        >
          {this.getHeaderLabelComponent({ label, tooltip })}
          <div style={headerRightComponentStyle}>
            <HeaderRightComponent column={column} />
          </div>
        </div>
      );
    }

    return this.getHeaderLabelComponent({ label, tooltip });
  };

  getHeaderData = columnList => {
    const { t, getCustomHeaderComponent } = this.props;
    const headerData = [];

    _.map(columnList, column => {
      const sortByOptions = column.sortByOptions;
      const sortType = column.sortType;
      const entity = column.entity;
      const alignment = _.get(column, "alignment", "");
      let dropdownOptions = sortByOptions ? [...sortByOptions] : [];

      dropdownOptions = _.map(dropdownOptions, dropdownOption => {
        return {
          key: dropdownOption.key,
          label: t(dropdownOption.label),
          direction: dropdownOption.direction,
          sortEntity: dropdownOption.sortEntity,
          icon: dropdownOption.icon,
        };
      });

      const value =
        column.showCustomHeader && getCustomHeaderComponent
          ? getCustomHeaderComponent({ column })
          : this.getHeaderValue({
              label: column.locale ? t(column.locale) : column.label,
              subText: column.subTextLocale
                ? t(column.subTextLocale)
                : column.subText,
              tooltip: column.headerTooltipLocale
                ? t(column.headerTooltipLocale)
                : null,
              id: column?.id,
              column,
            });

      headerData.push({
        key: column.id,
        value,
        style: column?.style ?? {},
        alignment: alignment
          ? alignment
          : _.includes(
              ["ACTIONS", "INTCOLUMN", "STATUS_THUMBS_OR_TICK"],
              column.type
            )
          ? "center"
          : "left",
        sortType: sortType ?? "",
        sortOptions: column.hasSortingEnabled ? dropdownOptions : [],
        entity: entity ?? "",
        isSticky: _.get(column, "isSticky", false),
        parent: column.parent ?? "root",
        children: column.children ?? [],
        level: column.level ?? 0,
        subText: column?.subTextLocale
          ? t(column?.subTextLocale)
          : column?.subText,
        isMasked: column?.isMasked,
        titleSuffix: column?.titleSuffix,
      });
    });
    return headerData;
  };
  getCellData = ({ column, id, columnData, isDisabled, isRowArchived }) => {
    const {
      getCustomComponent,
      t,
      useCustomFuncForDefault,
      showAvatar,
      avatarStyles,
      showArchivedText,
      getMultiRowEmptyComponent,
      getPopupContainer,
      nameWithLink: nameWithLinkFromProps,
      showVerticalActionButton = false,
      testId,
      dsVersion,
      placement = "bottomLeft",
      showSkeletonLoader,
    } = this.props;

    const nameWithLinkFromColumnData = _.get(columnData, "nameWithLink");

    const nameWithLink = !_.isUndefined(nameWithLinkFromColumnData)
      ? nameWithLinkFromColumnData
      : nameWithLinkFromProps;

    const userAvatarViewMode = _.get(column, "viewMode");
    const userAvatarCustomSubText = _.get(columnData, "customSubText");

    switch (column.type) {
      case "NAMEWITHIMAGE": {
        if (showSkeletonLoader) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <SkeletonLoader height="32px" width="32px" variant="circular" />
              <SkeletonLoader height="20px" width="120px" />
            </div>
          );
        }
        return (
          <UserNameAvatar
            id={columnData.id}
            profileImage={columnData.profileImage}
            name={columnData.name}
            email={columnData.email}
            customTooltip={columnData.customTooltip}
            tooltipContainerStyle={columnData?.tooltipContainerStyle}
            tooltipPlacement={columnData?.tooltipPlacement}
            nameWithLink={nameWithLink}
            shouldDynamicColor={columnData.shouldDynamicColor}
            isArchived={columnData.isArchived}
            showAvatar={showAvatar}
            avatarStyles={avatarStyles}
            showArchivedText={showArchivedText}
            profileTextStyle={isDisabled ? disabledStyle : {}}
            showArchivedLabel={column?.showArchivedLabel}
            emptyTextStyle={_.get(column, "emptyTextStyle", {})}
            emptyTextLocale={_.get(column, "emptyTextLocale")}
            showTooltip={!column.hideTooltip}
            profileCellStyle={_.get(column, "customCellStyle")}
            onProfileClick={
              _.isFunction(_.get(columnData, "onProfileClick"))
                ? columnData.onProfileClick
                : null
            }
            userNameAvatarWrapper={column?.userNameAvatarWrapper}
            userNameAvatarWrapperProps={columnData?.userNameAvatarWrapperProps}
            profileCascadeWrapper={column?.profileCascadeWrapper}
            profileCascadeWrapperProps={columnData?.profileCascadeWrapperProps}
            {...(userAvatarViewMode ? { viewMode: userAvatarViewMode } : {})}
            {...(userAvatarCustomSubText
              ? { customSubText: userAvatarCustomSubText }
              : {})}
            testId={testId}
            dir={column.dir}
            dsVersion={dsVersion}
            profileCascadeDsVersion={dsVersion}
            studentAlertsConfig={columnData?.studentAlertsConfig}
          />
        );
      }
      case "TEXTCOLUMN":
      case "INTCOLUMN": {
        if (showSkeletonLoader) {
          return <SkeletonLoader height="20px" width="100%" />;
        }
        return columnData;
      }
      case "CUSTOMSTYLESTEXT": {
        if (showSkeletonLoader) {
          return <SkeletonLoader height="20px" width="100%" />;
        }
        return <span style={column.textStyles}>{columnData}</span>;
      }
      case "ARRAYCOLUMNWITHOVER": {
        if (showSkeletonLoader) {
          return <SkeletonLoader height="20px" width="100%" />;
        }

        const columnNoItemsText = column?.arrayColumnNoItemsText;
        const noItemText = _.isEmpty(columnNoItemsText)
          ? t("common:no_with_label", { label: t(column.locale) })
          : columnNoItemsText;
        return (
          <MoreItemWithToolTip
            items={columnData ? columnData : []}
            length={1}
            noItemText={noItemText}
            moreStyle={
              isDisabled ? disabledStyle : _.get(column, "moreStyle", {})
            }
            emptyTextStyle={_.get(column, "emptyTextStyle", {})}
            containerStyle={{
              display: "flex",
              ..._.get(column, "containerStyle", {}),
            }}
            valueStyle={{ overflow: "hidden", textOverflow: "ellipsis" }}
            testId={`${testId}-${column.id}-${id}`}
          />
        );
      }
      case "MULTIROW": {
        const updatedColumn = update(column, {
          type: { $set: _.get(column, "subType") },
        });
        const singleRowStyles = _.get(column, "singleRowStyle", {});
        const containerStyles = _.get(column, "containerStyle", {});

        if (showSkeletonLoader) {
          return <SkeletonLoader height="20px" width="100%" />;
        }
        return !_.isEmpty(columnData) ? (
          <div className={classes.multiRowContainer} style={containerStyles}>
            {_.map(columnData, (item, index) => {
              const newColumnData = _.has(item, "data") ? item.data : item;
              const singleRowClass = classNames({
                [classes.singleRow]: true,
                [classes.archivedCell]: item?.isArchived && !isRowArchived,
              });
              return (
                <div
                  className={singleRowClass}
                  style={singleRowStyles}
                  key={index}
                >
                  {this.getCellData({
                    column: updatedColumn,
                    id,
                    columnData: newColumnData,
                  })}
                </div>
              );
            })}
          </div>
        ) : getMultiRowEmptyComponent ? (
          getMultiRowEmptyComponent({ column })
        ) : null;
      }
      case "ACTIONS": {
        if (showSkeletonLoader || _.isNil(columnData)) {
          return <SkeletonLoader height="20px" width="100%" />;
        }
        const actionOptions = [];
        _.map(columnData, option => {
          if (!option.isDivider) {
            actionOptions.push({
              key: option.key,
              label: option.label,
              subText: option.subText,
              icon: option.icon,
              isDestructive: option.isDestructive,
              disabled: option.disabled,
              disabledTooltip: option.disabledTooltip,
              tooltipPlacement: option.tooltipPlacement,
              isSubMenu: option.isSubMenu,
              options: option.options,
            });
          } else {
            actionOptions.push({
              isDivider: option.isDivider,
            });
          }
        });

        const onClick = obj => {
          // in case of subMenu items keyPath will be an array like ["subMenuItemKey", "menuItemKey"]
          // otherwise it will be just ["menuItemKey"]
          const keyPath = obj.keyPath;
          let data = columnData;
          let selectedAction;
          while (_.size(keyPath) > 0) {
            const key = keyPath.pop();
            selectedAction = _.filter(data, option => option.key === key)[0];
            data = selectedAction.options;
          }
          selectedAction.clickAction(selectedAction.key, id);

          // If shouldFocusOnActionDropdownOnActionClick is true, the focus will be on the dropdown icon after the dropdown is closed.
          // This allows components that handle focus explicitly (like modals) to correctly return focus to the dropdown icon.
          if (
            _.get(
              selectedAction,
              "shouldFocusOnActionDropdownOnActionClick",
              false
            ) &&
            !_.isNil(this.actionDropdownIconRef.current)
          ) {
            this.actionDropdownIconRef.current?.focus();
          }
        };

        return (
          !_.isEmpty(columnData) && (
            <Dropdown
              getPopupContainer={getPopupContainer}
              placement={placement}
              overlay={
                <DropdownMenu
                  options={actionOptions}
                  onClick={onClick}
                  dsVersion={dsVersion}
                  shouldStopPropagation
                  testId={
                    this.props.testId
                      ? `${this.props.testId}-${id}-action`
                      : undefined
                  }
                />
              }
              overlayStyle={{ zIndex: 225, ...column.dropdownStyles }}
              disabled={_.get(column, "disabled", false)}
            >
              <IconButton
                icon={
                  showVerticalActionButton ? (
                    <DotsVerticalOutlined />
                  ) : (
                    <DotsHorizontalOutlined />
                  )
                }
                _legacy_variant="plain"
                size="medium"
                _legacy_size="small"
                shouldStopPropagation
                testId={
                  this.props.testId
                    ? `${this.props.testId}-${id}-action`
                    : undefined
                }
                ref={this.actionDropdownIconRef}
                variant="neutral"
                type="plain"
                dsVersion={dsVersion}
              />
            </Dropdown>
          )
        );
      }
      case "CUSTOM":
        if (getCustomComponent) {
          return getCustomComponent({
            column,
            columnData,
            id,
            t,
            isDisabled,
          });
        }
        break;
      default:
        if (useCustomFuncForDefault && getCustomComponent) {
          return getCustomComponent({
            column,
            columnData,
            id,
            t,
            isDisabled,
          });
        } else {
          return null;
        }
    }
    return null;
  };

  getCellStyle = ({ column, row }) => {
    if (_.isEqual(column.type, "MULTIROW")) {
      return multiRowColumnStyle;
    }

    const commonCellStyles = _.get(
      row,
      ["cellStyles", "commonCellStyles"],
      null
    );

    // if all cells have common styles,
    if (commonCellStyles) {
      return commonCellStyles;
    }

    return _.get(row, ["cellStyles", column.id], {});
  };

  getRowSpanOfCell = ({ column, row }) => {
    return _.get(row, ["rowSpan", column.id], 1);
  };

  getBodyData = (columnList, feedData, disabled, allowEmptyCells) => {
    feedData = this.getOrderBy({ feedData });
    const bodyData = [];
    _.map(feedData, row => {
      const rowData = [];
      const isDisabled = _.get(row, "isDisabled", false);
      const isGrouped = _.get(row, "isGrouped", false);
      const isArchived = _.get(row, "isArchived", false);
      const disableRowClick = _.get(row, "disableRowClick", false);
      const isCheckboxDisabled = _.get(row, "isCheckboxDisabled", false);

      if (isGrouped) {
        rowData.push({
          key: row.columnId,
          value: row.value,
          colSpan: row.colSpan,
          isRowArchived: isArchived,
          style: _.get(row, "cellStyles", {}),
        });
      } else {
        _.map(columnList, column => {
          if (!allowEmptyCells) {
            !_.isNil(row[column.id]) &&
              rowData.push({
                key: column.id,
                value: this.getCellData({
                  column,
                  id: row.id,
                  columnData: row[column.id],
                  isDisabled,
                  isRowArchived: isArchived,
                }),
                style: this.getCellStyle({
                  column,
                  row,
                }),
                colSpan: column.colSpan ? column.colSpan : row.colSpan,
                valueTooltipMaxWidth: column.valueTooltipMaxWidth,
                rowSpan: this.getRowSpanOfCell({
                  column,
                  row,
                }),
              });
          } else {
            rowData.push({
              key: column.id,
              value: this.getCellData({
                column,
                id: row.id,
                columnData: row[column.id],
                isDisabled,
                isRowArchived: isArchived,
              }),
              style: this.getCellStyle({
                column,
                row,
              }),
              valueTooltipMaxWidth: column.valueTooltipMaxWidth,
            });
          }
        });
      }
      bodyData.push({
        id: row.id,
        rowData,
        isArchived,
        isDisabled,
        isGrouped,
        disableRowClick,
        // isCheckboxDisabled is used to disable single row checkbox
        // and disabled is used to disable all row checkboxes, for backward compatibility
        isCheckboxDisabled: isCheckboxDisabled || disabled,
      });
    });
    return bodyData;
  };

  renderFeedList = () => {
    const {
      feedData,
      columnList,
      onItemClick,
      enableStickyHeader = false,
      scrollContainerRef,
      onRowSelection,
      hiddenColumns = [],
      rowsSelected,
      headerTheme,
      showBorder,
      tableId,
      disabled,
      allowEmptyCells = true,
      isSelectAllCheckboxDisabled = false,
      onSelectAllCheckboxClick,
      showRowBackgroundOnHover,
      testId,
      tableSize,
      dsVersion,
      customFilterConfig,
      handleCustomFilterConfig,
      // pagination & virtualization props (forwarded to DS Table)
      height,
      rowHeight,
      overScan,
      loader,
      onScrollEnd,
    } = this.props;

    return (
      <Table
        headers={this.getHeaderData(columnList)}
        data={this.getBodyData(columnList, feedData, disabled, allowEmptyCells)}
        onRowClick={onItemClick}
        isHeaderFixed={enableStickyHeader}
        filterCallback={filterConfig => {
          this.onFitlerDropdownOptionClick(filterConfig);
          handleCustomFilterConfig
            ? handleCustomFilterConfig({ filterConfig })
            : this.setState({ filterConfig });
        }}
        filterConfig={
          customFilterConfig ? customFilterConfig : this.state.filterConfig
        }
        scrollContainerRef={scrollContainerRef}
        rowsSelected={rowsSelected}
        onRowSelection={onRowSelection}
        hiddenColumns={hiddenColumns}
        headerTheme={headerTheme}
        showBorder={showBorder}
        tableId={tableId}
        isSelectAllCheckboxDisabled={isSelectAllCheckboxDisabled}
        onSelectAllCheckboxClick={onSelectAllCheckboxClick}
        testId={testId}
        size={tableSize}
        showRowBackgroundOnHover={showRowBackgroundOnHover}
        height={height}
        rowHeight={rowHeight}
        overscan={overScan}
        loader={loader}
        onScrollEnd={onScrollEnd}
        {...(dsVersion ? { dsVersion } : {})}
      />
    );
  };

  render() {
    const {
      feedData,
      containerStyle,
      emptyComponent,
      countString,
      isData,
      isLoading,
      containerListStyle,
      showSkeletonLoader,
      testId,
    } = this.props;

    return (
      <div className={classes.container} style={containerStyle}>
        <div
          className={classes.containerList}
          style={containerListStyle}
          id={"feedList-container-list"}
        >
          {countString && (
            <div className={classes.listCountText}>{countString}</div>
          )}
          {_.size(feedData) !== 0 && this.renderFeedList()}
          {isLoading && !showSkeletonLoader && <Loading />}
          {feedData.length == 0 && isData && !isLoading ? (
            emptyComponent ? (
              emptyComponent
            ) : (
              <NoDataComponent testId={testId} />
            )
          ) : null}
        </div>
      </div>
    );
  }
}

FeedListv2.defaultProps = {
  showHeaderRow: true,
  containerStyle: {},
  innerContainerStyle: {},
  tooltipHrefValue: "#",
  isGrouped: false,
  subHeaderStyle: {},
  headerTheme: "light",
  showBorder: false,
  tableSize: "large",
  containerListStyle: {},
  testId: "appComponents",
  showRowBackgroundOnHover: true,
  showSkeletonLoader: false,
};

FeedListv2.propTypes = {
  showHeaderRow: PropTypes.bool,
  containerStyle: PropTypes.object,
  innerContainerStyle: PropTypes.object,
  tooltipHrefValue: PropTypes.string,
  isGrouped: PropTypes.bool,
  subHeaderStyle: PropTypes.object,
  headerTheme: PropTypes.oneOf(["light", "dark", "subtle"]),
  showBorder: PropTypes.bool,
  tableId: PropTypes.string,
  tableSize: PropTypes.string,
  containerListStyle: PropTypes.object,
  testId: PropTypes.string,
  showRowBackgroundOnHover: PropTypes.bool,
  showSkeletonLoader: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowHeight: PropTypes.number,
  overScan: PropTypes.number,
  loader: PropTypes.node,
  onScrollEnd: PropTypes.func,
};

export default I18nHOC({ resource: ["common"] })(FeedListv2);
